import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SponsorStudy } from '../sponsor-dashboard/sponsor-study';
import { SponsorStudiesStorage } from '../sponsor-dashboard/sponsor-studies-storage';
import { UrlBuilder } from '../core';
import { findProtocolId } from '../shared/route-helpers';

@Injectable()
export class SelectedStudyResolver implements Resolve<SponsorStudy> {

    constructor(
        private readonly sponsorStudiesStorage: SponsorStudiesStorage,
        private readonly urlBuilder: UrlBuilder,
    ) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SponsorStudy> {
        const protocolId = findProtocolId(route);

        return this.sponsorStudiesStorage.loadStudies()
            .pipe(
                map(studies => {
                    const selectedStudy = studies.find(study => study.protocolId === protocolId);
                    if (!selectedStudy) {
                        this.urlBuilder.esa().navigate();
                    }

                    return selectedStudy;
                }));
    }
}